import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import ExportBlob from '../../../../common/export-blob';
import { getCurrentDate } from '../../../../helpers/Common';
import { downloadTopValue } from '../reducer';

class Export extends React.Component {
  handleExport = () => {
    const { downloadTopValue, typeTab, filter } = this.props;
    const name = `${I18n.t(`common.export.topMover.${typeTab}`, {
      date: getCurrentDate(),
      name: I18n.t('common.listComponent.TopValue'),
    })}`;

    downloadTopValue(filter, typeTab, name);
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
});

const mapDispatchToProps = {
  downloadTopValue,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Export);
